import { axios } from "@app/services";
import { IRegisterProps } from "./types";

export const register = async (props: IRegisterProps): Promise<IRegisterProps> => {
    const response = await axios.post<IRegisterProps>("auth/register", props);

    return response.data;
};
